module.exports = __webpack_public_path__ + "media/thumbnails/head-style-1-d2653c0c.svg";